export default "__VITE_ASSET__D7bgT4ZX__"